export const mockData = {
  product: {
    name: "Rasputin",
    tagline: "Molho Picante",
    description: "O molho mais intenso que você já experimentou. Rasputin combina as pimentas mais ardentes com um sabor único que desafia os limites do seu paladar.",
    heatLevel: 9.5, // out of 10
    features: [
      {
        title: "Extremamente Picante",
        description: "Feito com as pimentas mais potentes do mundo"
      },
      {
        title: "Sabor Único",
        description: "Blend exclusivo que equilibra calor e sabor"
      },
      {
        title: "Ingredientes Naturais",
        description: "100% natural, sem conservantes artificiais"
      },
      {
        title: "Produção Artesanal",
        description: "Cada garrafa é cuidadosamente preparada"
      }
    ],
    pepperTypes: [
      { name: "Carolina Reaper", level: 10, scoville: "2.200.000 SHU" },
      { name: "Trinidad Scorpion", level: 9.5, scoville: "1.400.000 SHU" },
      { name: "Habanero", level: 8, scoville: "350.000 SHU" },
      { name: "Jalapeño", level: 5, scoville: "8.000 SHU" }
    ]
  },
  gallery: [
    {
      id: 1,
      title: "Pimentas Ardentes",
      image: "https://images.unsplash.com/photo-1610216339841-a0456a6c86a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxob3QlMjBwZXBwZXJzfGVufDB8fHxyZWR8MTc3NDI4ODc2MXww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 2,
      title: "Intensidade Máxima",
      image: "https://images.pexels.com/photos/1558916/pexels-photo-1558916.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    },
    {
      id: 3,
      title: "Pimentas Grelhadas",
      image: "https://images.unsplash.com/photo-1568137896147-713ddc8ec822?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHxob3QlMjBwZXBwZXJzfGVufDB8fHxyZWR8MTc3NDI4ODc2MXww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 4,
      title: "Variedade Habanero",
      image: "https://images.pexels.com/photos/1374651/pexels-photo-1374651.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    },
    {
      id: 5,
      title: "Fogo Puro",
      image: "https://images.pexels.com/photos/207353/pexels-photo-207353.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    }
  ],
  contact: {
    email: "Contato@rasputin.com.br",
    phone: "(19) 9 7788-4455"
  },
  heroImage: "https://images.pexels.com/photos/1558916/pexels-photo-1558916.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
};
